import styled from "styled-components";

export const Container = styled.section`
  display: grid;
  grid-template-columns: 350px 40vw;
  align-items: center;
  grid-column-gap: 194px;
  align-content: center;
  align-items: start;
  padding: 72px 0px;
  margin-left: 5.5%;

  .playlist-img {
    width: 100px;
  }

  .playlist {
    /* margin-top: 64px; */
    padding: 40px;
    padding-top: 0px;
    width: 100%;
    color: ${(props) => props.theme.textLight};
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .playlists {
    display: flex;
    flex-direction: column;
    margin-top: 40px;

    .playlist-title {
      margin-bottom: 12px;
      font-family: ${(props) => props.theme.p1m.ff};
      font-size: ${(props) => props.theme.p1b.fs};
    }
    .playlist-card {
      display: flex;
      margin-bottom: 40px;
      cursor: pointer;
      transition: transform 0.3s ease-in-out;

      .playlist-img {
        min-width: 100px;
        width: 100px;
        height: 100px;
        object-fit: cover;
      }

      .right-content {
        margin-left: 24px;
      }

      .playlist-description {
        font-family: ${(props) => props.theme.p3r.ff};
        font-size: ${(props) => props.theme.p3r.fs};
        color: ${(props) => props.theme.textLight};
      }
    }

    .playlist-card:hover {
      transform: scale(1.005);
    }
  }

  .sessions {
    justify-self: center;
  }

  .sessions-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 15px;
    margin-top: 40px;

    .playlist-img {
      cursor: pointer;
      width: 123px;
      transition: transform 0.3s ease-in-out;
    }

    .playlist-img:hover {
      transform: scale(1.02);
    }
  }

  @media (max-width: 1000px) {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 90%;
    padding: 52px 0px;
    padding-top: 42px;
    height: fit-content;
    /* margin-left: -8%; */

    .playlist {
      width: 100%;
      margin-top: 0px;
    }

    .playlists {
      margin-top: 0px;
    }
    .sessions {
      width: 100%;
      margin-top: -20px;
    }

    .sessions-list {
      grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
      grid-column-gap: 40px;
      margin-top: 0px;
    }
  }

  @media (max-width: 420px) {
    .playlist-img {
      &:nth-child(even) {
        margin-left: -30%;
      }
    }
  }
`;
